import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Button from "react-bootstrap/Button";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import logo from '../../src/Assets/logo.png'

function Header() {
  const navigate = useNavigate();

  const handleViewMoreClick = () => {
    navigate('/contactus'); // Ensure this route exists in your router
  };
  return (
    <Navbar
      expand="lg"
      style={{
        backgroundColor: "#E3EBD4",
        position: "fixed",
        top: "0",
        width: "100%",
        zIndex: "1000",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Black shadow at the bottom
      }}
    >
      <Container>
        {/* Logo Image on the Left */}
        <Navbar.Brand href="/">
          <img
            src={logo}
            alt="Logo"
            style={{ maxHeight: "50px" }}
          />
        </Navbar.Brand>

        {/* Navbar Toggle for Mobile View */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-between">
          {/* Centered Links */}
          <Nav className="mx-auto">
            {/* Home Link */}
            <RouterLink
              to="/"
              style={{
                color: "black",
                fontWeight: "bold",
                textTransform: "uppercase",
                fontSize: "15px",

                margin: "10px 20px",
                cursor: "pointer",
                textDecoration: "none", // Ensure no underline or different styles
              }}
            >
              Home
            </RouterLink>

            {/* About Us Link */}
            <Nav.Link
              as={ScrollLink}
              to="aboutus"
              smooth={true}
              duration={500}
              style={{
                color: "black",
                fontWeight: "bold",
                textTransform: "uppercase",
                fontSize: "15px",
                margin: "0 20px",
                cursor: "pointer",
              }}
            >
              About Us
            </Nav.Link>


            {/* Products Link */}
            <Nav.Link
              as={ScrollLink}
              to="products"
              smooth={true}
              duration={500}
              style={{
                color: "black",
                fontWeight: "bold",
                textTransform: "uppercase",
                fontSize: "15px",
                margin: "0 20px",
                cursor: "pointer",
              }}
            >
              Products
            </Nav.Link>

            {/* Our Partners Dropdown */}
            <NavDropdown
              title="Our Partners"
              id="basic-nav-dropdown"
              style={{
                color: "black",
                fontWeight: "bold",
                textTransform: "uppercase",
                fontSize: "15px",
                margin: "0 20px",
              }}
            >
              <NavDropdown.Item href="/sonxproducts">Son-x</NavDropdown.Item>
              <NavDropdown.Item href="/foodproducts">My Food</NavDropdown.Item>
            </NavDropdown>

            {/* Contact Link */}
            <Nav.Link
              href="/contactus"
              style={{
                color: "black",
                fontWeight: "bold",
                textTransform: "uppercase",
                fontSize: "15px",
                margin: "0 20px",
              }}
            >
              Contact
            </Nav.Link>
          </Nav>

          {/* Right-aligned Button */}
          <Button
            href="#enquiry"
            style={{
              backgroundColor: "#98AF41",
              borderColor: "#98AF41",
              color: "white",
              borderRadius: "20px",
              padding: "0.5rem 1.5rem",
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
            onClick={handleViewMoreClick}
          >
            Send an Enquiry
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
